import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Radio } from 'antd';
import React, { Component } from 'react';

type StateType ={
  selectedValue: string;
  search?: string;
  searchedValuesReturn: any;
  searchReady: boolean;
}

type PropType = {
  reset: boolean;
  renderedData: any[];
  radio?: boolean;
  setProcess: Function;
  resetFunction: Function;
  value: any;
}


export default class CheckboxSearch extends Component<PropType, StateType> {
  constructor(props: PropType){
    super(props)

    this.state = {
      selectedValue: '',
      search: '',
      searchedValuesReturn: [],
      searchReady: false
    }
  }

  UNSAFE_componentWillReceiveProps = ( nextProps: any ) => {
    if(nextProps.reset){
      this.reset()
    }
  }

  onRadioChange = async (e: any) => {
    this.setState({selectedValue: e.target.value})
    await this.props.setProcess(e.target.value)
  }

  handleInput = async (e: any) => {
    this.setState({search: e.target.value})
    if(this.state.searchReady){
      this.setState({ searchReady: false })
    }
  }

  generateFilteredData = async () => {
    const { search } = this.state
    const { renderedData } = this.props
    if(renderedData && renderedData.items){
      let returnedVals = renderedData.items.map((e: any) => e.name.toLowerCase().includes(search.toLowerCase()) ? e : '')
      returnedVals = returnedVals.filter((e:any) => e)
      console.log('returnedVals', returnedVals)
      this.setState({ searchedValuesReturn: returnedVals })
      this.setState({searchReady: true}) 
    }
  }

  returnFilteredData = () => {
    const returnedProcesses:JSX.Element[] = []
    const { renderedData } = this.props
    if(this.state.searchReady){
      for(let process of this.state.searchedValuesReturn){
        returnedProcesses.push(
          <Radio key={process.id} style={radioStyle} value={process.id}>
              {process.name}
          </Radio>
        )
      }
    } else {
      if(renderedData && renderedData.items){
        for(let process of renderedData.items){
          returnedProcesses.push(
            <Radio key={process.id} style={radioStyle} value={process.id}>
                {process.name}
            </Radio>
          )
        }
      } 
    }

    return returnedProcesses
  }

  reset = async () => {
    this.setState({search: ''})
    this.props.resetFunction(false)
  }

  render() {
    return (
      <Wrapper>
        <div className="search-bar">
          <input value={this.state.search} onChange={this.handleInput} className="input" placeholder={I18n.l('common.search')}>
          </input>
          <button onClick={this.generateFilteredData} className="search-button">
            <FontAwesomeIcon icon={'search'}/>
          </button>
        </div>
        <div className="content">
          { this.props.radio &&
          <Radio.Group onChange={this.onRadioChange} value={this.props.value ? this.props.value : undefined}>
              {this.returnFilteredData()}
          </Radio.Group> }
        </div>
      </Wrapper>
    )
  }
}

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
}

const Wrapper = styled.div`
height: 160px;
width: 100%;
border: 1px solid #B5B5B5;
border-radius: 5px;
display: flex;
flex-direction: column;



.search-bar{
  width: 100%;
  height: 30%;
  background-color: rgba(255,255,255,1);
  border-radius: 5px 5px 0px 0px;
  border-bottom: 1px solid #B5B5B5;
  display: flex;
  flex: 1;
}

.content{
  flex: 3;
  width: 100%;
  height: 100%;
  padding: 10px 20px;
  background-color: white;
  border-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 10px;
    border-radius: 20px;
}
::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
    background: #555;
}


  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
}

.input{
  border-radius: 10px 10px 0 0;
  border: none;
  flex: 5;
  font-size: 1em;
  padding: 10px;

}
.search-button{
  flex: 1;
  border: none;
  background-color: white;
  border-radius: 10px;
  cursor: pointer;
}

`
